import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-708615b7")

_pushScopeId("data-v-708615b7")
const _hoisted_1 = {
  class: "bg-gray-lp-1000 h-full flex flex-col",
  "data-testid": "pickup-list-page"
}
const _hoisted_2 = { class: "flex flex-shrink-0 items-center justify-between border-b border-gray-lp-1400 bg-white px-6 py-1.5" }
const _hoisted_3 = { class: "flex flex-grow flex-col gap-y-3 overflow-hidden p-4" }
const _hoisted_4 = { class: "overflow-auto h-full" }
const _hoisted_5 = { class: "flex flex-col items-start gap-y-1" }
const _hoisted_6 = { class: "flex gap-x-1" }
const _hoisted_7 = {
  key: 0,
  class: "rounded px-1.5 py-px bg-red-lp-3100 text-red-lp-2400 font-medium text-8px"
}
const _hoisted_8 = {
  key: 1,
  class: "rounded px-1.5 py-px bg-yellow-lp-200 text-yellow-lp-100 font-medium text-8px"
}
const _hoisted_9 = {
  key: 2,
  class: "rounded px-1.5 py-px bg-chocolate-lp-400 text-white font-medium text-8px"
}
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "flex flex-col items-start gap-y-1" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = {
  key: 1,
  class: "overflow-ellipsis text-left font-semibold"
}
const _hoisted_14 = {
  key: 0,
  class: "flex items-center gap-x-1"
}
const _hoisted_15 = { class: "font-normal" }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "rounded-full px-1.5 py-px bg-gray-lp-200 text-black-lp-300 font-medium text-xs"
}
const _hoisted_18 = { class: "font-semibold" }
const _hoisted_19 = { class: "flex flex-col items-start gap-y-1 w-full" }
const _hoisted_20 = { class: "w-full truncate text-left break-words" }
const _hoisted_21 = { class: "w-full truncate text-left text-gray-lp-800 break-words" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Title = _resolveComponent("Title")!
  const _component_CalendarOutlined = _resolveComponent("CalendarOutlined")!
  const _component_PickupCorporateV2SummaryCard = _resolveComponent("PickupCorporateV2SummaryCard")!
  const _component_PickupBookingSummary = _resolveComponent("PickupBookingSummary")!
  const _component_ListPickupFilterBar = _resolveComponent("ListPickupFilterBar")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_PickupStatusBadge = _resolveComponent("PickupStatusBadge")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Card = _resolveComponent("Card")!
  const _component_ModalRequestPickup = _resolveComponent("ModalRequestPickup")!
  const _component_ModalActivePickupWarning = _resolveComponent("ModalActivePickupWarning")!
  const _component_ModalSelectClientSchedule = _resolveComponent("ModalSelectClientSchedule")!
  const _component_ModalPickupRequestSuccess = _resolveComponent("ModalPickupRequestSuccess")!
  const _component_SavedAddressList = _resolveComponent("SavedAddressList")!
  const _component_ModalAddNewAddress = _resolveComponent("ModalAddNewAddress")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Title, {
          label: _ctx.$t('pickupV2.list.title'),
          fontSize: 20,
          bold: "semibold"
        }, null, 8, ["label"]),
        (!_ctx.isDhlWhitelist)
          ? (_openBlock(), _createBlock("button", {
              key: 0,
              type: "button",
              "data-testid": "pickup-list-button-schedule-config",
              class: [
          'flex items-center gap-2 rounded-md border px-3 py-2 text-12px font-semibold',
          !_ctx.validationAccount
            ? 'border-gray-lp-600 bg-white text-gray-lp-600 cursor-not-allowed'
            : ' bg-white cursor-pointer new-red'
        ],
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onOpenScheduleConfig && _ctx.onOpenScheduleConfig(...args))),
              disabled: !_ctx.validationAccount
            }, [
              _createVNode(_component_CalendarOutlined, { class: "h-4 w-4" }),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("pickupV2.list.createConfig")), 1)
            ], 10, ["disabled"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_3, [
        (!_ctx.isInternalAccount)
          ? (_openBlock(), _createBlock(_component_PickupCorporateV2SummaryCard, {
              key: 0,
              data: _ctx.pickupCorporateSummary,
              loading: _ctx.apiSummaryData.loading
            }, null, 8, ["data", "loading"]))
          : _createCommentVNode("", true),
        _createVNode(_component_PickupBookingSummary, {
          summaryData: _ctx.pickupCorporateSummary,
          onRequestPickup: _ctx.onRequestPickup,
          onLihatStt: _ctx.onViewStt,
          onUbahAlamat: _ctx.onOpenSavedAddressList,
          onTambahAlamat: _ctx.showModalAddAddress,
          onBuatPickupManual: _ctx.onOpenModalRequestPickupManual,
          showChangeAddress: true,
          showPickupCta: false,
          loading: _ctx.apiSummaryData.loading,
          isInternalAccount: _ctx.isInternalAccount
        }, null, 8, ["summaryData", "onRequestPickup", "onLihatStt", "onUbahAlamat", "onTambahAlamat", "onBuatPickupManual", "loading", "isInternalAccount"]),
        _createVNode(_component_Card, {
          rounded: "xl",
          class: "bg-white flex flex-col flex-grow gap-y-3 overflow-hidden w-full p-4"
        }, {
          default: _withId(() => [
            _createVNode(_component_ListPickupFilterBar, {
              ref: "listPickupFilterBarRef",
              modelValue: _ctx.filter,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.filter = $event)),
              loading: _ctx.apiListData.loading,
              isV2: "",
              onFilter: _ctx.onChangeAdvancedFilter,
              onReset: _ctx.onResetAdvancedFilter
            }, null, 8, ["modelValue", "loading", "onFilter", "onReset"]),
            _createVNode("div", _hoisted_4, [
              (
              !_ctx.listData.data.length &&
                !_ctx.apiListData.loading &&
                !_ctx.apiListData.errorType
            )
                ? (_openBlock(), _createBlock(_component_EmptyState, {
                    key: 0,
                    icon: _ctx.iconEmpty,
                    customHeaderMessage: _ctx.emptyHeaderMessage,
                    customMessage: _ctx.emptyMessage
                  }, null, 8, ["icon", "customHeaderMessage", "customMessage"]))
                : (_openBlock(), _createBlock(_component_TableV2, {
                    key: 1,
                    "data-testid": "pickup-list-table",
                    loading: _ctx.apiListData.loading,
                    borderTop: false,
                    borderBottom: false,
                    isSpaceTop: false,
                    isDetailAble: false,
                    columns: _ctx.columns,
                    data: _ctx.listData.data,
                    sortBy: _ctx.activeSortBy,
                    sortDirection: _ctx.activeSortDirection,
                    onSort: _ctx.onSort,
                    errorCause: _ctx.apiListData.errorType,
                    pagination: _ctx.listData.pagination,
                    "onUpdate:pagination": _cache[3] || (_cache[3] = ($event: any) => (_ctx.listData.pagination = $event)),
                    onRequest: _ctx.getListPickupList,
                    onTryAgain: _ctx.getListPickupList,
                    bgHeader: "bg-white border-t border-gray-lp-1400",
                    isBorderOnHeadBgWhite: "",
                    isPinnedScrollBottom: "",
                    pinnedSubstractHeight: _ctx.isInternalAccount ? '300px' : '472px',
                    paginationStyle: "v3",
                    customClassPagination: "absolute w-full bottom-4 right-0 left-0 -mb-4 px-8",
                    paginationV3PaddingVertical: "py-4"
                  }, {
                    orderId: _withId(({ item }) => [
                      _createVNode("div", _hoisted_5, [
                        _createVNode("button", {
                          class: "underline text-sm text-red-lp-100",
                          onClick: () => _ctx.onToDetail(item)
                        }, _toDisplayString(item.shipmentId), 9, ["onClick"]),
                        _createVNode("div", _hoisted_6, [
                          (item.isDg)
                            ? (_openBlock(), _createBlock("span", _hoisted_7, " DG "))
                            : _createCommentVNode("", true),
                          (item.isQuarantine)
                            ? (_openBlock(), _createBlock("span", _hoisted_8, " K "))
                            : _createCommentVNode("", true),
                          (item.isWoodPacking)
                            ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.$t("pickupV2.list.wood")), 1))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ]),
                    status: _withId(({ item }) => [
                      (item.latestStatus)
                        ? (_openBlock(), _createBlock(_component_PickupStatusBadge, {
                            key: 0,
                            "data-testid": "pickup-list-status-badge",
                            statusCode: item.latestStatus
                          }, null, 8, ["statusCode"]))
                        : (_openBlock(), _createBlock("span", _hoisted_10, " - "))
                    ]),
                    totalPickup: _withId(({ item }) => [
                      _createVNode("div", _hoisted_11, [
                        (!item.actualTotalShipment && !item.actualTotalKoli)
                          ? (_openBlock(), _createBlock("span", _hoisted_12, " - "))
                          : (_openBlock(), _createBlock("div", _hoisted_13, [
                              (item.actualTotalShipment)
                                ? (_openBlock(), _createBlock("div", _hoisted_14, [
                                    _createVNode("span", null, _toDisplayString(`${_ctx.formatNumber(item.actualTotalShipment)} AWB`), 1),
                                    _createVNode("span", _hoisted_15, _toDisplayString(`(${_ctx.formatNumber(item.actualTotalKoli)} ${_ctx.$t(
                          "pickupV2.list.piece"
                        )})`), 1)
                                  ]))
                                : (_openBlock(), _createBlock("span", _hoisted_16, _toDisplayString(`${_ctx.formatNumber(item.actualTotalKoli)} ${_ctx.$t(
                        "pickupV2.list.piece"
                      )}`), 1))
                            ])),
                        (item.additionalKoli)
                          ? (_openBlock(), _createBlock("span", _hoisted_17, [
                              _createTextVNode(" + " + _toDisplayString(_ctx.$t("pickupV2.list.additional")) + " ", 1),
                              _createVNode("span", _hoisted_18, _toDisplayString(_ctx.formatNumber(item.additionalKoli)) + " " + _toDisplayString(_ctx.$t("pickupV2.list.piece")), 1)
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    klien: _withId(({ item }) => [
                      _createVNode("div", _hoisted_19, [
                        _createVNode("div", _hoisted_20, _toDisplayString(_ctx.formatClientName(item.clientRef) || "-"), 1),
                        _createVNode("div", _hoisted_21, _toDisplayString(item.clientCode || "-"), 1)
                      ])
                    ]),
                    _: 1
                  }, 8, ["loading", "columns", "data", "sortBy", "sortDirection", "onSort", "errorCause", "pagination", "onRequest", "onTryAgain", "pinnedSubstractHeight"]))
            ])
          ]),
          _: 1
        })
      ])
    ]),
    _withDirectives(_createVNode(_component_ModalRequestPickup, {
      "is-shown": _ctx.openModalRequestPickup,
      mode: _ctx.requestPickupMode,
      prefill: _ctx.requestPickupPrefill,
      onClose: () => (_ctx.openModalRequestPickup = false),
      onSuccess: _ctx.onRequestPickupSuccess
    }, null, 8, ["is-shown", "mode", "prefill", "onClose", "onSuccess"]), [
      [_vShow, _ctx.openModalRequestPickup]
    ]),
    _createVNode(_component_ModalActivePickupWarning, {
      isOpen: _ctx.isActivePickupWarningOpen,
      onCancel: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isActivePickupWarningOpen = false)),
      onConfirm: _ctx.onOpenModalRequestPickup
    }, null, 8, ["isOpen", "onConfirm"]),
    _withDirectives(_createVNode(_component_ModalSelectClientSchedule, {
      "is-shown": _ctx.showSelectClientSchedule,
      onClose: () => (_ctx.showSelectClientSchedule = false),
      onContinue: _ctx.onSelectClientScheduleContinue
    }, null, 8, ["is-shown", "onClose", "onContinue"]), [
      [_vShow, _ctx.showSelectClientSchedule]
    ]),
    _createVNode(_component_ModalPickupRequestSuccess, {
      visible: _ctx.openModalPickupRequestSuccess,
      "order-id": _ctx.pickupSuccess.orderId,
      "total-koli": _ctx.pickupSuccess.totalKoli,
      "total-weight-kg": _ctx.pickupSuccess.totalWeightKg,
      "pickup-date": _ctx.pickupSuccess.pickupDate,
      "pickup-time-start": _ctx.pickupSuccess.pickupTimeStart,
      "label-url": _ctx.pickupSuccess.labelUrl,
      onClose: _ctx.onCloseModalPickupRequestSuccess
    }, null, 8, ["visible", "order-id", "total-koli", "total-weight-kg", "pickup-date", "pickup-time-start", "label-url", "onClose"]),
    _withDirectives(_createVNode(_component_SavedAddressList, {
      isShown: _ctx.isChangeAddressOpen,
      "onUpdate:isShown": _cache[5] || (_cache[5] = ($event: any) => (_ctx.isChangeAddressOpen = $event)),
      selectedAddress: _ctx.selectedAddress,
      onSelectAddress: _ctx.onSelectAddress,
      onDefaultAddressChanged: _ctx.onDefaultAddressChanged,
      onAddressFormSuccess: _ctx.onAddressFormSuccess,
      onAddressDeleted: _ctx.onAddressDeleted
    }, null, 8, ["isShown", "selectedAddress", "onSelectAddress", "onDefaultAddressChanged", "onAddressFormSuccess", "onAddressDeleted"]), [
      [_vShow, _ctx.isChangeAddressOpen]
    ]),
    _withDirectives(_createVNode(_component_ModalAddNewAddress, {
      formType: "add",
      isVisible: _ctx.isAddAddress,
      onClose: _ctx.closeModalAddAddress,
      forceDefault: true,
      onOnSuccess: _ctx.onAddressFormSuccess
    }, null, 8, ["isVisible", "onClose", "onOnSuccess"]), [
      [_vShow, _ctx.isAddAddress]
    ])
  ], 64))
})